import React from 'react';
import { X, AlertCircle, CheckCircle, Info, AlertTriangle } from 'lucide-react';
import { useTranslation } from '../i18n';

const AlertModal = ({
  isOpen,
  onClose,
  title,
  message,
  type = 'info', // 'info' | 'success' | 'error' | 'warning'
  buttonText,
  onConfirm,
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const icons = {
    info: <Info size={24} className="text-blue-500" />,
    success: <CheckCircle size={24} className="text-primary-500" />,
    error: <AlertCircle size={24} className="text-red-500" />,
    warning: <AlertTriangle size={24} className="text-amber-500" />,
  };

  const buttonColors = {
    info: 'bg-brand-primary hover:bg-brand-primary-hover',
    success: 'bg-primary-600 hover:bg-primary-700',
    error: 'bg-red-600 hover:bg-red-700',
    warning: 'bg-amber-600 hover:bg-amber-700',
  };

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    onClose();
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-xl max-w-sm w-full mx-4 overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-5 border-b border-gray-200">
          <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
            {icons[type]}
            {title || t('modals.alertDefaultTitle')}
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition"
          >
            <X size={20} />
          </button>
        </div>
        <div className="p-5">
          <p className="text-gray-600 mb-6">{message}</p>
          <button
            onClick={handleConfirm}
            className={`w-full px-4 py-2.5 text-white rounded-xl font-medium transition ${buttonColors[type]}`}
          >
            {buttonText || t('common.ok')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
